import React, { ReactElement } from 'react';
import { makeStyles } from 'tss-react/mui';

import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';

import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

interface ILineProps {
  stakedPercent: number;
}

export function Line({ stakedPercent }: ILineProps): ReactElement {
  const { classes, cx } = useStyles({
    stakedPercent,
  });
  const { t, keys } = useTranslation(mergedTranslation);

  const nonStakedPercent = 100 - stakedPercent;

  return (
    <div>
      <div className={classes.description}>
        <div className={classes.item}>
          <div className={cx(classes.decoration, classes.white)} />

          {t(
            keys.stakedToken,
            {
              token: t(keys.tokens.native),
              percent: stakedPercent,
            },
            true,
          )}
        </div>

        <div className={classes.item}>
          <div className={classes.decoration} />

          {t(
            keys.nonStakedToken,
            {
              token: t(keys.tokens.native),
              percent: nonStakedPercent,
            },
            true,
          )}
        </div>
      </div>

      <div className={classes.lineWrap}>
        <div className={cx(classes.lineStaked, classes.line)} />

        <div className={cx(classes.lineNonStaked, classes.line)} />
      </div>
    </div>
  );
}

const useStyles = makeStyles<{ stakedPercent: number }>()(
  (theme, { stakedPercent }) => ({
    description: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 16,
      fontWeight: 500,

      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    decoration: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: theme.palette.background.default,
    },
    white: {
      backgroundColor: theme.palette.secondary.contrastText,
    },
    lineWrap: {
      display: 'flex',
      gap: stakedPercent === 0 ? 0 : theme.spacing(1),
    },
    line: {
      height: 16,
      borderRadius: 4,
      marginTop: theme.spacing(2.5),
    },
    lineStaked: {
      width: `${stakedPercent}%`,
      backgroundColor: theme.palette.secondary.contrastText,
    },
    lineNonStaked: {
      width: `${100 - stakedPercent}%`,
      backgroundColor: theme.palette.background.default,
    },
  }),
);
